module.exports = __webpack_public_path__ + "img/smartphone-em-praia-direcionamento.jpg";